import { useMutation, useQueryClient } from '@tanstack/react-query'

import { notificationsClient } from './notifications.service'

export const useUpdateNotificationStatus = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: notificationsClient.updateNotificationStatus,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['userNotifications'],
      })
      await queryClient.invalidateQueries({
        queryKey: ['userNotificationsCount'],
      })
    },
  })
}
